import injectBlock from "./inject-block.js";

import BasicInfo from "./basic-info.js";

export const BlockInfo = injectBlock("info");
export const BlockDanger = injectBlock("danger");
export const BlockWarning = injectBlock("warning");
export const BlockDefault = injectBlock("default");
export const BlockSuccess = injectBlock("success");
export const BlockHelp = injectBlock("help");

export {
  BasicInfo
};



// WEBPACK FOOTER //
// ./bricks/bricks.js